import { LOGIN_URL } from '../constants'

export function useHomeLogin() {
    const handleLogin = () => {
        window.location.href = LOGIN_URL
    }

    return { handleLogin }
}
